import pickBy from 'lodash/pickBy';
import identity from 'lodash/identity';
import map from 'lodash/map';
import noop from 'lodash/noop';
import GlobalStorageService from './GlobalStorageService';
import StorageConstants from '../constants/StorageConstants';
import TelemetryConstants from '../constants/TelemetryConstants';
import AppService from './AppService';

const getUniqueName = eventData => {
  return `${eventData[0]}-${eventData[1]}-${eventData[2]}`;
};

const getEventName = eventData => {
  return eventData[eventData.length - 1] || TelemetryConstants.NO_EVENT_NAME;
};

const getEventData = (eventData, others = {}) => {
  return pickBy(
    {
      [TelemetryConstants.PRODUCT]: TelemetryConstants.KINGDOMS.MITRA_PWA,
      [TelemetryConstants.LATEST_SOURCE]:
        AppService.getUTMSource() || AppService.getAndSetUTMSource() || 'default',
      [TelemetryConstants.GROUP]: eventData[0],
      [TelemetryConstants.SCREEN]: eventData[1],
      ...others,
    },
    identity
  );
};

const sendEvent = (eventData = [], others, cb = noop) => {
  if (process.env.REACT_APP_CHANNEL === 'dev')
    console.log('Events', {
      eventName: getEventName(eventData),
      eventData: getEventData(eventData, others),
    });
  const Telemetry = GlobalStorageService.getItem(StorageConstants.TELEMETRY);
  Telemetry && Telemetry.sendEvent(getEventName(eventData), getEventData(eventData, others), cb);
};

const flushEvents = () => {
  const cachedEvents = GlobalStorageService.getItem(StorageConstants.TELEMETRY_EVENTS) || {};
  map(Object.keys(cachedEvents), k => {
    sendEvent(cachedEvents[k].eventData, cachedEvents[k].others);
  });
  GlobalStorageService.setItem(StorageConstants.TELEMETRY_EVENTS, {});
};

const cacheEvent = (eventData = [], others) => {
  let cachedEvents = GlobalStorageService.getItem(StorageConstants.TELEMETRY_EVENTS) || {};
  if (Object.keys(cachedEvents).length <= 2) {
    cachedEvents[getUniqueName(eventData)] = { eventData, others };
  } else {
    flushEvents();
    cachedEvents = {};
    cachedEvents[getUniqueName(eventData)] = { eventData, others };
  }
  GlobalStorageService.setItem(StorageConstants.TELEMETRY_EVENTS, cachedEvents);
};

const initiateAutoFlush = () => {
  setInterval(() => {
    flushEvents();
  }, 1000);
};

export default {
  setUser() {
    const Telemetry = GlobalStorageService.getItem(StorageConstants.TELEMETRY);
    Telemetry && Telemetry.setUser();
  },

  sendEvent: cacheEvent,

  initiateAutoFlush,
};
